export const CategoryList = [
  { href: "/", jpLabel: "製品カテゴリA", enLabel: "category", key: "001" },
  { href: "/", jpLabel: "製品カテゴリB", enLabel: "category", key: "002" },
  { href: "/", jpLabel: "製品カテゴリC", enLabel: "category", key: "003" },
  { href: "/", jpLabel: "製品カテゴリD", enLabel: "category", key: "004" },
  { href: "/", jpLabel: "製品カテゴリE", enLabel: "category", key: "005" },
];
